export default __webpack_public_path__ + "static/media/breakfast.97a04de1.png";